import { create } from "zustand";
import { GetFinancialYearLockData } from "../services/AccountsApi";

const useFinancialYearLockStore = create((set, get) => ({
  lockedFyList: [],
  lockedIntervals: [],
  isLoaded: false,
  loading: false,

  fetchLockedFinancialYears: async (force = false) => {
    if (get().isLoaded && !force) return;

    set({ loading: true });
    try {
      const res = await GetFinancialYearLockData();
      if (res && res.data && Array.isArray(res.data.fy_list)) {
        const locked = res.data.fy_list.filter(
          (fy) => fy.status === "locked" || fy.status === "closed"
        );
        const intervals = locked.map((fy) => ({
          start: new Date(fy.start_date),
          end: new Date(fy.end_date),
          name: fy.name,
        }));

        set({
          lockedFyList: locked,
          lockedIntervals: intervals,
          isLoaded: true,
          loading: false,
        });
      }
    } catch (err) {
      console.error("Failed to fetch locked financial years:", err);
      set({ loading: false, isLoaded: true, lockedIntervals: [] });
    }
  },

  refreshLockStatus: () => get().fetchLockedFinancialYears(true),

  clearFinancialYearLockStore: () =>
    set({ lockedFyList: [], lockedIntervals: [], isLoaded: false, loading: false }),
}));

export default useFinancialYearLockStore;
